import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
// import { immer } from "zustand/middleware/immer";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import idbKeyvalAdapter from "./1_utility";
import devDebug from "../Helpers/debug";

// define the initial state
const initialState = {
  animatedOnce: false,
  success: false,
  dashboardData: {
    dashboard_logged_in: {
      all: {
        total_tenders: 0,
        recent_tenders: 0,
        tenders_expiring_in_3_days: 0,
      },
    },
    dashboard_anonymous: {
      anonymous: {
        total_tenders: 0,
        recent_tenders: 0,
        tenders_expiring_in_3_days: 0,
      },
    },
  },
  getError: false,
  dashboardDataLoading: true,
  shortTermLoadingMarket: true,
  shortTermLoadingStrategy: true,
  longTermLoading: true,
  shortTermDataMarket: { last_month_avg: "0", last_week: "0", this_week: "0" },
  shortTermDataStrategy: {
    last_month_avg: "0",
    last_week: "0",
    this_week: "0",
  },
  longTermChartData: {
    all: [],
    strategy_cpvs: [],
    strategy_nuts: [],
    strategy: [],
  },
  donutData: {},

  submitErrors: { all: "" },
  errType: { all: "" },
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useDashboardStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      // ------------------- DASHBOARD -----------------------
      setSuccess: (payload) =>
        set((state) => {
          state.success = payload;
        }),
      setAnimatedOnce: (payload) =>
        set((state) => {
          state.animatedOnce = payload;
        }),
      setDashboardData: (resp, section, id) =>
        set((state) => {
          state.dashboardData[section][id] = resp;
          state.loading = false;
          state.success = true;
        }),
      setGetError: (payload) =>
        set((state) => {
          state.getError = payload;
        }),
      setDashboardDataLoading: (payload) =>
        set((state) => {
          state.dashboardDataLoading = payload;
        }),
      setShortTermLoadingMarket: (payload) =>
        set((state) => {
          state.shortTermLoadingMarket = payload;
        }),
      setShortTermLoadingStrategy: (payload) =>
        set((state) => {
          state.shortTermLoadingStrategy = payload;
        }),
      setLongTermLoading: (payload) =>
        set((state) => {
          state.longTermLoading = payload;
        }),
      setShortTermDataMarket: (payload) =>
        set((state) => {
          state.shortTermDataMarket = payload;
        }),
      setShortTermDataStrategy: (payload) =>
        set((state) => {
          state.shortTermDataStrategy = payload;
        }),
      setLongTermChartData: (payload) =>
        set((state) => {
          state.longTermChartData = payload;
        }),
      setDonutData: (payload) =>
        set((state) => {
          state.donutData = payload;
        }),
      setDonutLoading: (payload) =>
        set((state) => {
          state.donutLoading = payload;
        }),
      resetState: () => {
        useDashboardStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              ![
                "tenderStrategyStatus",
                "tenderStrategies",
                "CPVStage",
                "NUTSMapStage",
                "user",
                "userLoaded",
                "strategyIDs",
                "animatedOnce",
                "dashboardDataLoading",
              ].includes(key)
          )
        ),
      name: "dashboardStore",
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[dashboardStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[dashboardStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[dashboardStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[dashboardStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[dashboardStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[dashboardStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[dashboardStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[dashboardStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[dashboardStore] Error during rehydration. Store name: "dashboardStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[dashboardStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
